import React from 'react';
interface ScrollImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  className?: string;
}
export function ScrollImage({
  className = '',
  ...props
}: ScrollImageProps) {
  const handleClick = () => {
    const target = document.getElementById('comprar');
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  return <img {...props} onClick={handleClick} className={`cursor-pointer transition-transform hover:scale-[1.02] ${className}`} data-id="element-198" />;
}